<template>
  <div>
    <v-navigation-drawer
      :value="isAddNewDepartamentoSidebarActive"
      temporary
      touchless
      :right="!$vuetify.rtl"
      :width="$vuetify.breakpoint.smAndUp ? 350 : '100%'"
      app
      @input="val => $emit('update:is-add-new-departamento-sidebar-active', val)"
    >
      <v-card height="100%">
        <div class="drawer-header d-flex align-center mb-4">
          <span class="font-weight-semibold text-base text--primary">Adicionar Departamento</span>
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            @click="$emit('update:is-add-new-departamento-sidebar-active', false)"
          >
            <v-icon size="22">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </div>

        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
            @submit.prevent="onSubmit"
          >
            <v-text-field
              v-model="departamentoData.nome"
              outlined
              dense
              :rules="[validators.required]"
              label="Nome"
              placeholder="Nome"
              hide-details="auto"
              class="mb-6"
            ></v-text-field>

            <v-textarea
              v-model="departamentoData.descricao"
              outlined
              dense
              auto-grow
              label="Descrição"
              placeholder="Descrição"
              hint="Máximo de 300 caracteres"
              hide-details="auto"
              class="mb-6"
            ></v-textarea>

            <v-btn
              color="primary"
              class="me-3 mb-1"
              type="submit"
            >
              <v-progress-circular
                v-if="loadings"
                class="mx-6"
                indeterminate
                color="secundary"
              ></v-progress-circular>
              <span v-else> Adicionar </span>
            </v-btn>
            <v-btn
              color="secondary"
              class="mb-1"
              outlined
              type="reset"
              @click="resetdepartamentoData"
            >
              Cancelar
            </v-btn>
          </v-form>

          <v-alert
            v-if="msgsSuccess"
            class="mt-4"
            dense
            dismissible
            type="success"
          >
            Cadastrado com sucesso!
          </v-alert>
          <v-alert
            v-if="msgsError"
            class="mt-4"
            shaped
            outlined
            type="error"
          >
            {{ errorMsg }}
          </v-alert>
        </v-card-text>
      </v-card>
    </v-navigation-drawer>
  </div>
</template>

<script>
import {
  nameValidator,
  emailValidator,
  passwordValidator,
  required,
  select,
} from '@core/utils/validation'
import { mdiClose, mdiEyeOffOutline, mdiEyeOutline } from '@mdi/js'
import { ref } from '@vue/composition-api'
import { isTelefoneCelularValido, isCpfValido } from '@/utils/validation'
import DepartamentoService from '@/services/modules/DepartamentoService'

export default {
  model: {
    prop: 'isAddNewDepartamentoSidebarActive',
    event: 'update:is-add-new-departamento-sidebar-active',
  },
  props: {
    isAddNewDepartamentoSidebarActive: {
      type: Boolean,
      required: true,
    },
  },

  setup(props, { emit }) {
    const blankdepartamentoData = {
      nome: '',
      descricao: '',
    }

    const valid = ref(false)
    const form = ref(null)

    const msgsSuccess = ref(false)
    const msgsError = ref(false)
    const loadings = ref(false)

    const validate = () => {
      form.value.validate()
    }

    const resetForm = () => {
      form.value.reset()
    }

    const departamentoData = ref(JSON.parse(JSON.stringify(blankdepartamentoData)))
    const errorMsg = ref('Entre em contato com o servidor.')

    const resetdepartamentoData = () => {
      msgsError.value = false
      departamentoData.value = JSON.parse(JSON.stringify(blankdepartamentoData))
      resetForm()
      setTimeout(() => {
        emit('update:is-add-new-departamento-sidebar-active', false)
      }, 2000)
    }

    const onSubmit = () => {
      loadings.value = !loadings.value

      if (valid.value) {
        DepartamentoService
          .criar(departamentoData.value)
          .then(() => {
            loadings.value = !loadings.value
            msgsSuccess.value = !msgsSuccess.value
            setTimeout(() => {
              msgsSuccess.value = !msgsSuccess.value
            }, 6000)
            emit('refetch-data')
            resetdepartamentoData()
          })
          .catch(() => {
            msgsError.value = !msgsError.value
            setTimeout(() => {
              msgsError.value = !msgsError.value
            }, 6000)
            loadings.value = !loadings.value
          })
      } else {
        loadings.value = !loadings.value
        validate()
      }
    }

    return {
      resetdepartamentoData,
      onSubmit,
      validate,
      form,
      departamentoData,
      valid,
      msgsSuccess,
      msgsError,
      blankdepartamentoData,
      loadings,
      errorMsg,
      validators: {
        required,
        emailValidator,
        select,
        nameValidator,
        isCpfValido,
        passwordValidator,
        isTelefoneCelularValido,
      },
      icons: {
        mdiClose,
        mdiEyeOffOutline,
        mdiEyeOutline,
      },
    }
  },
}
</script>
